import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import gtmHandler from "AtomicUtils/gtmHandler"
import { DownloadIcon } from "components"
import COLOR_PALETTE from "constants/color-palette"
import { withRadium, Radium, DetectCompact } from "higher-order-components"
import { H5, Space, A, Interactive, Content } from "AtomicComponents"
import classnames from "classnames"
import typographyStyles from "AtomicComponents/Typography/Typography.less"

const RadiumLink = Radium(Link)

const MyMazdaDynamicResourceItem = props => {
  const {
    compact,
    gtm,
    heading,
    description,
    imageSrc,
    buttonLinkText,
    buttonUrl,
    isDownload = false,
    isExternal = false,
    itemLayout
  } = props
  const tall = itemLayout === "tall"

  return (
    <div style={styles.tile(compact, tall)}>
      <div
        style={{
          display: itemLayout === "tall"? "block" : "flex",
          flexDirection: itemLayout === "tall" ? "column" : "row",
          position: "relative"
        }}>
        <div style={styles.image(tall)}>
          <img style={{ maxWidth: "100%" }} src={imageSrc} />
        </div>
        <div style={{ padding: `0 0 2em ${tall ? "0" : "1em"}`, flex: "1 1 78%" }}>
          <H5 withDetails>{heading}</H5>
          <Space />
          {description && (
            <Content
              xmlString={description}
              textAlign="left"
              style={{ color: tall ? COLOR_PALETTE.BLACK : COLOR_PALETTE.GRAY_DARK }} />
          )}
        </div>
      </div>
      <div style={{ padding: tall ? "0" : "0 0 1em", textAlign: "center" }}>
        <div style={styles.hr} />
        {isDownload || isExternal ? (
          <A
            href={buttonUrl}
            withoutStyle
            external
            onClick={() => {
              gtmHandler({
                pageCategory: `MyMazda - ${gtm.category}`,
                pageAction: `${heading.toUpperCase()} - clicked "${buttonLinkText.toUpperCase()}"`
              })
            }}>
            {
              isDownload &&
              <DownloadIcon
                style={{
                  height: "12px",
                  width: "14px",
                  fill: "#999999",
                  marginRight: "0.5em"
                }}
              />
            }
            <Interactive>{buttonLinkText}</Interactive>
          </A>
        ) : (
          <RadiumLink
            to={buttonUrl}
            className={classnames({
              [typographyStyles.withoutStyle]: true
            })}>
            <Interactive>{buttonLinkText}</Interactive>
          </RadiumLink>
        )}
      </div>
    </div>
  )
}

const styles = {
  tile: (compact, tall) => ({
    position: "relative",
    overflow: "hidden",
    display: "flex",
    backgroundColor: "white",
    boxSizing: "border-box",
    border: `1px solid ${COLOR_PALETTE.GRAY}`,
    flexDirection: "column",
    padding: tall ? "1.5em 1em 1em" : compact ? "2em 1.5em 0" : "3em 2.5em 0",
    margin: tall ? "0 1em 2em 1em" : compact ? "0 0 2em" : "0 1em 2em",
    justifyContent: "space-between",
    textAlign: tall ? "center" : "left",
    width: tall ? "280px" : "100%",
    maxWidth: tall ? "280px" : compact ? "470px" : "420px"
  }),
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em"
  },
  button: {
    color: COLOR_PALETTE.GRAY_DARK,
    transition: "color 0.25s",
    cursor: "pointer",
    ":hover": {
      color: COLOR_PALETTE.GRAY_DARKER,
      fill: COLOR_PALETTE.GRAY_DARKER
    },
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "87%"
  },
  image: tall => ({
    position: "relative",
    boxSizing: "border-box",
    flex: "1 1 30%",
    maxHeight: tall ? "none" : "85px",
    paddingBottom: "2em"
  })
}

MyMazdaDynamicResourceItem.propTypes = {
  compact: PropTypes.bool,
  heading: PropTypes.string,
  description: PropTypes.string,
  imageSrc: PropTypes.string,
  itemLayout: PropTypes.oneOf(["wide", "tall"]),
  buttonLinkText: PropTypes.string,
  buttonUrl: PropTypes.string,
  isDownload: PropTypes.bool
}

MyMazdaDynamicResourceItem.defaultProps = {
  itemLayout: "wide"
}

export default withRadium(DetectCompact())(MyMazdaDynamicResourceItem)



// WEBPACK FOOTER //
// ./src/blocks/mymazda/dynamic-resource/item.jsx